import { useParams } from "react-router-dom";
import { decryptProfile } from "../utils/profileCrypto";
import DashboardHeaderSection from "../components/common/dashboardheader/DashboardHeader";
import ClubLinksProfile from "../components/payments/ClubLinksProfile";
import { Container, createTheme, Grid, ThemeProvider } from "@mui/material";

const theme = createTheme({
    typography: {
        fontFamily: ['Quicksand', 'Playfair Display'].join(','),
        fontSize: 12
    },
    palette: {
        primary: {
            main: "#FF5200",
        },
        secondary: {
            main: "#ff9800",
        },

        payment: {
            activeTab: "#3c44bc",
            inactiveTab: "#6c757d",
            pending: "#0D6EFD",
            success: "#198754",
            rejected: "#DC3545",
            waiting: "#0DCAF0",
            applied: "#ffc107",
            background: "#F5F6FA",
            border: "#E5E7EB",
        },
    }
})

function CreatorOrVendorProfile() {
    const { token } = useParams();
    const { id, isVen } = decryptProfile(token);

    if (!id) {
        window.location.href = "/";
        return;
    }

    return (
        <>
            <DashboardHeaderSection />
            <ThemeProvider
                theme={theme}
            >
                <Container
                    sx={{
                        marginTop: 8,
                        paddingLeft: 10
                    }}
                    maxWidth={false}
                    disableGutters
                >
                    <Grid
                        container
                    >
                        <Grid
                            item
                            xs={12}
                        >
                            <ClubLinksProfile
                                id={id}
                                isVen={isVen}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </ThemeProvider>
        </>
    )
}

export default CreatorOrVendorProfile;